import { lazy, Suspense } from 'react';

const HpRespPersonalizedCategories = lazy(() =>
    import(/* webpackChunkName: "HpRespPersonalizedCategories" */ './HpRespPersonalizedCategories')
);

export function HpRespPersonalizedCategoriesLoader(props) {
    return (
        <Suspense fallback={null}>
            <HpRespPersonalizedCategories {...props} />
        </Suspense>
    );
}
